import { Button, CircularProgress, Modal } from "@mui/joy";
import { BASE_URL, WHITE } from "../../../appConstants";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import appError from "../../../appError";
import axios from "axios";
import CrossIcon from "../../../svg/Ads_Dashboard_Developement2/CrossIcon/elements.svg";
import toast from "react-hot-toast";

type AccessPlatformModalProps = {
  accessType: string;
  userId: string;
  userMail: string;
  selectedBrand: string;
  setSelectedBrand: Dispatch<SetStateAction<string>>;
  setAccessToggle: Dispatch<SetStateAction<boolean>>;
};
type Platform = {
  platform_id: string;
  platform: string;
};
const AccessPlatformModal: React.FC<AccessPlatformModalProps> = ({
  accessType,
  userId,
  userMail,
  selectedBrand,
  setSelectedBrand,
  setAccessToggle,
}) => {
  const [platforms, setPlatforms] = useState<Platform[]>([]);
  const [selectedPlatform, setSelectedPlatform] = useState<Platform>({} as Platform);
  const [loading, setLoading] = useState<boolean>(false);
  const [platformsFetchingDataState, setPlatformsFetchingDataState] =
    useState<string>("");

  const fetchPlatforms = async () => {
    if (!userId) return;
    if (!selectedBrand) return;

    const token = localStorage.getItem("token");
    try {
      setPlatformsFetchingDataState("LOADING");
      const api = `${BASE_URL}user/getPlatformByUser?user_id=${userId}&brand_id=${selectedBrand}`;
      const headers = { Authorization: `Bearer ${token}` };
      const result = await axios.get(api, { headers });
      const { platforms } = result?.data?.data;
      if (platforms?.length > 0) {
        setPlatforms(platforms);
        setPlatformsFetchingDataState("SUCCESS");
      } else {
        setPlatformsFetchingDataState("EMPTY");
      }
    } catch (error) {
      appError(error);
    }
  };

  useEffect(() => {
    fetchPlatforms();
  }, []);

  const platformChangeHandler = (ag_platform: Platform) => {
    setSelectedPlatform(ag_platform)
  };

  const onProceedChangeHandler = async () => {
    const token = localStorage.getItem("token");
    try {
        setLoading(true);
        const headers = {
            Authorization: `Bearer ${token}`,
          };
        const res = await axios.post(
            `${BASE_URL}brand/apiAccessMail?user_mail=${userMail}&brand_id=${selectedBrand}&platform_id=${selectedPlatform?.platform_id}&platform=${selectedPlatform?.platform}&accessType=${accessType}`, {},
            {headers}
          );

        if(res?.data?.status === "success"){
            toast.success(`Mail Send`);
            setSelectedPlatform({} as Platform);
            setSelectedBrand('');
            setAccessToggle(false);
        }

    } catch (error) {
        appError(error);
    } finally {
        setLoading(false);
    }
  };

  return (
    <Modal
      open={true}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      className="h-full"
    >
      <div
        style={{ width: 700, backgroundColor: `${WHITE.W_100}` }}
        className="h-[400px] relative flex flex-col items-center rounded-[18px] px-10 py-10 gap-10"
      >
        {platformsFetchingDataState === "LOADING" ? (
          <div className="h-full w-full flex justify-center items-center">
            <CircularProgress />
          </div>
        ) : platformsFetchingDataState === "SUCCESS" ? (
          <div className="h-full w-full flex flex-col justify-between gap-10">
            <div className="flex justify-between gap-1 w-full">
              <div className="flex flex-col w-[60%]">
                <div
                  className="self-stretch"
                  style={{
                    color: `#1C1C1E`,
                    fontSize: 20,
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "26px",
                  }}
                >
                  Select Platform
                </div>
                <div
                  className="self-stetch"
                  style={{
                    color: `#97979A`,
                    fontSize: 14,
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "22px",
                  }}
                >
                  Select Platform for which you want to take Access
                </div>
              </div>
            </div>

            <div className="grid grid-cols-4 gap-x-10 gap-y-4 w-full">
              {platforms?.map((platform) => {
                return (
                  <label
                    className="flex items-center gap-2"
                    key={platform?.platform_id}
                  >
                    <input
                      type="radio"
                      name="options"
                      value="keywordmapping"
                      checked={selectedPlatform?.platform_id === platform?.platform_id}
                      style={{
                        width: 16,
                        height: 16,
                        accentColor: "black",
                        cursor: "pointer",
                      }}
                      onChange={() => platformChangeHandler(platform)}
                    />
                    {platform?.platform}
                  </label>
                );
              })}
            </div>

            <div className="flex items-start justify-center gap-[30px] self-stretch">
              <Button
                color="neutral"
                sx={{
                  height: "40px",
                  width: "50%",
                  backgroundColor: "#FFF",
                  ":hover": {
                    backgroundColor: "#FFF",
                  },
                  color: "#1C1C1E",
                  borderRadius: "8px",
                  border: "1px solid #F2F2F5",
                  padding: "0px 8px",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "18px",
                }}
                onClick={() =>{ 
                  setSelectedBrand('');
                  setAccessToggle(false)
                } }
              >
                Cancel
              </Button>
              <Button
                onClick={() => onProceedChangeHandler()}
                sx={{
                  height: "40px",
                  width: "50%",
                  backgroundColor: "#1565C0",
                  color: "#FFF",
                  borderRadius: "8px",
                  padding: "0px 8px",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "18px",
                }}
                disabled={selectedPlatform?.platform_id === ""}
              >
                Proceed
              </Button>
            </div>
          </div>
        ) : (
          <div className="h-full w-full flex justify-center items-center">
            <div
              style={{
                color: `#1C1C1E`,
                fontSize: 20,
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "26px",
              }}
            >
              No Brands Assigned
            </div>
          </div>
        )}

        {platformsFetchingDataState !== "LOADING" && (
          <div
            className="absolute top-4 right-4 flex p-1 "
            style={{
              zIndex: 100,
              backgroundColor: "#F2F2F5",
              borderRadius: "20px",
            }}
          >
            <img
              src={CrossIcon}
              alt="OverView Icon"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSelectedBrand('');
                setAccessToggle(false);
              }}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AccessPlatformModal;
